function authGuard(store) {
  return (to, from, next) => {
    if (!store.getters.authCheck) {
      next({ name: APP_ROUTENAME_LOGIN })
    } else {
      next()
    }
  }
}

export default authGuard
